import { defineStore } from 'pinia';
import API_ENDPOINTS from '~/utils/apiEndpoints.js';

export const useSettingsStore = defineStore('settings', {
  
  state: () => ({
    loaderItem: false,
    settings: {}
  }),


  actions: {
    async getSettings(locale) {
        this.loaderItem = true
      try {
        const response = await $fetch(API_ENDPOINTS.getSettings, {
          server: false,
          method: 'GET',
          headers: { locale },
        });
        this.settings = response || {};
        this.loaderItem = false
        return response
      } catch (err) {
        // console.error('Error fetching settings:', err.message || err);
      }
    },
  },

  persist: true,
});
